import JwPlayer from "common/Layout/Article/components/JwPlayer";
import YouTube from "common/Layout/Article/components/YouTube";
import { FC } from "react";

type Props = {
  hero: any;
};

const VideoPlayer: FC<Props> = ({ hero }) => {
  switch (hero.type) {
    case "jw_player":
      return (
        <JwPlayer
          url={hero?.data.extra.sources[6].file}
          caption={hero?.data.extra.truncatedTitle}
        />
      );
    case "youtube":
      return <YouTube data={hero.data} />;

    case "video-youtube":
      return <YouTube data={hero.data} />;

    default:
      return null;
  }
};

export default VideoPlayer;
